import { ProcessActivityStatus, StepStatus } from '@common/enums';
import type { Color, IGraphSizes, IPosition } from '../helpers';
import type { IProcessWorkflowStep } from '../WorkflowGraph';
import { Rectangle } from './Rectangle';
import { StepLabel } from './StepLabel';

interface IActivityStepProps {
    graphSizes: IGraphSizes;
    label: string;
    onMouseOut: () => void;
    onMouseOver: () => void;
    position: IPosition;
    processWorkflowStep: IProcessWorkflowStep | undefined;
}

export function ActivityStep(props: IActivityStepProps) {
    const { label, processWorkflowStep, position, graphSizes, onMouseOver, onMouseOut } = props;

    // activities is an array but that's deprecated; so simply use the first element of the array
    const processActivity = processWorkflowStep?.processActivities?.[0];

    let borderColor: Color = 'blue';
    let fillColor: Color = 'lightblue';
    let textColor: Color = 'black';
    switch (processWorkflowStep?.status) {
        case StepStatus.available:
            borderColor = 'green';
            fillColor = 'white';
            break;
        case StepStatus.cancelled:
            borderColor = 'grey';
            fillColor = 'grey';
            break;
        case StepStatus.failed:
            borderColor = 'red';
            fillColor = 'red';
            textColor = 'white';
            break;
        case StepStatus.finished:
            borderColor = 'green';
            fillColor = 'green';
            break;
        case StepStatus.inProgress:
            borderColor = 'yellow';
            fillColor = 'yellow';
            break;
        case StepStatus.obsolete:
            borderColor = 'red';
            fillColor = 'green';
    }

    if (processActivity && processActivity.status === ProcessActivityStatus.complete) {
        fillColor = 'lightgreen';
    }

    if (processActivity && processActivity.status === ProcessActivityStatus.cancelled) {
        fillColor = 'lightgrey';
    }

    if (processActivity && processActivity.status === ProcessActivityStatus.draft) {
        borderColor = 'lightyellow';
    }

    return (
        <>
            <Rectangle
                borderColor={borderColor}
                borderWidth={8}
                fillColor={fillColor}
                graphSizes={graphSizes}
                position={position}
            />
            <StepLabel
                color={textColor}
                graphSizes={graphSizes}
                label={label}
                onMouseOut={onMouseOut}
                onMouseOver={onMouseOver}
                position={position}
            />
        </>
    );
}
